module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/c6d6ad1ab6e136a54dd4c91128451693.png";